<!--  -->
<template>
  <div class="content">
    <cx-head v-if="windowWidth<=768"/>
    <b-container fluid>
      <img
        class="top_img"
        width="100%"
        src="../../static/img/stage/top_img.png"
      />
    </b-container>
    <div
      class="mianbao"
      toggleable="lg"
    >
      <div class="mianbao_view">
        <div
          v-for="(item,index) in mianbaoList"
          :key="index"
          class="mianbao_item"
          @click="goAnchor(item.id,index)"
          :class="{active:index==i}"
        >{{item.label}}</div>
      </div>
    </div>
    <div
      class="stage"
      id="title1"
    >
      <div class="title_img">
        <img
          class="title_img1"
          width="100%"
          src="../../static/img/stage/title1.png"
        />
        <div class="title_text">房车驿站</div>
      </div>
      <div class="stage_view">
        <div class="stage_text">
          快乐车行房车驿站项目是快乐车行全力打造的线下服务平台，以房车驿站为媒介，为房车露营爱好者提供房车旅游线路咨询、房车使用、异地租还车、房车补给等服务。实现信息共享、资源共享，一站式服务解决“异地还车、用车、加水、充电”等痛点，让越来越多的房车旅游爱好者都能享受到便捷、舒适的房旅生活。
        </div>
        <img
          class="stage_img"
          width="100%"
          src="../../static/img/stage/1.png"
        />
      </div>
    </div>
    <div
      class="answer_view"
      id="title2"
    >
      <div class="title_img">
        <img
          class="title_img1"
          width="100%"
          src="../../static/img/stage/title2.png"
        />
        <div class="title_text">驿站问答</div>
      </div>
      <div
        class="answer_list"
        style="margin-top:20px;"
      >
        <div
          class="answer_item"
          v-for="(item,index) in answerList1"
          :key="index"
        >
          <div class="answer_left">
            {{item.id}}
          </div>
          <div class="answer_right">
            <p style="font-weight:bold;color:#222;font-size:18px">{{item.title}}</p>
            <p style="color:#666;font-size:16px;text-align:justify;">{{item.answer}}</p>
          </div>
        </div>
        <div
          v-show="isMore"
          class="ic_more"
        >
          <div
            @click="loadMore"
            style="color:#666;margin-top:15px;font-size:16px;cursor: pointer;"
          >查看更多 ></div>
          <!-- <img
            @click="loadMore"
            width="72"
            src="../../static/img/stage/ic_more.png"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import api from '../api/api.js';
import cxHead from '@/components/cx-head.vue';
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
    cxHead,
  },
	metaInfo() {
		return {
			title: this.pageName, // set a title
			meta: [
				{
					// set meta
					name: 'keyWords',
					content: this.SeoKeyword,
				},
				{
					name: 'description',
					content: this.SeoDescription,
				},
			],
		};
	},
	data() {
		//这里存放数据
		return {
      windowWidth: window.innerWidth,
			pageName: '',
			SeoKeyword: '',
			SeoDescription: '',
			isMore: true,
			i: 0,
			mianbaoList: [
				{
					label: '房车驿站',
					path: '#',
					id: '#title1',
				},
				{
					label: '驿站问答',
					path: '#',
					id: '#title2',
				},
			],
			answerList: [
				{
					id: '01',
					title: '房车驿站尺寸材质？',
					answer:
						'车体为三明治式复合厢板，外推式车窗，配备遮阳板，房车门带纱门；厢外轮廓尺寸 长x宽x高（5762mm x 2560mm x 2500mm），厢体室内尺寸 长x宽x高（4476mm x 2010mm x 2090mm）。',
				},
				{
					id: '02',
					title: '房车驿站存在的价值？',
					answer:
						'房车驿站项目，致力于解决房旅休闲出行的水电及生活补给等难题，完美契合当下“地摊经济”热点，是助推“文旅复苏”政策的最佳落实者。房车开到哪里，哪里就有驿站服务，让房车爱好者无后顾之忧。',
				},
				{
					id: '03',
					title: '房车驿站对企业上市产生的影响？',
					answer:
						'房车驿站能够巩固伊宅购快乐车行在国内房旅企业的龙头地位，给伊宅购在资本市场上带来溢价，同时它是一个非常创新的商业模式，把这个项目实施好、执行好的话，它的成长性相对来讲就会非常强。而在公司营收和业务拓展呈现200%、300%这样的高成长性阶段去上市的话，将拉升企业上市市值。',
				},
				{
					id: '04',
					title: '房车驿站商业用途有哪些方面？',
					answer:
						'除了为房车提供补给，还可以做办公室，以及做移动店铺，进行房车的售卖与租赁，提供户外装备、房车旅游线路及门票、地方特产等旅游相关的产品服务。',
				},
				{
					id: '05',
					title: '房车驿站还可做移动店铺？',
					answer: '除了可以开店，房车驿站项目会为你提供营销思路+营销方法+源头产品+培训，让你开店就是赚。',
				},
				{
					id: '06',
					title: '房车驿站可摆放到哪些地方？',
					answer: '景区、营地、公园、商业圈、广场、社区等，房车驿站摆放位置越好，所产生的经济效益越高。',
				},
				{
					id: '07',
					title: '房车驿站公司是否给摆放或经营？',
					answer: '经营与摆放都是个人行为，公司不承诺经营与摆放。',
				},
				{
					id: '08',
					title: '房车驿站摆放冰柜尺寸？',
					answer: '高800mm，宽1256mm，深650mm。',
				},
				{
					id: '09',
					title: '房车驿站摆放的空调尺寸？',
					answer: '建议1p空调，室内机尺寸845×275×180(mm)；室外机尺寸776×540×320(mm)。',
				},
				{
					id: '10',
					title: '房车驿站水电路的接通？',
					answer: '个人与景区单位协商办理。',
				},
				{
					id: '11',
					title: '房车驿站收费方式？',
					answer: '扫码支付，公司与驿站t+1结算。',
				},
				{
					id: '12',
					title: '房车驿站如何运输到目的地？',
					answer: '公司负责送到指定城市，具体摆放位置及安装由个人负责安放。',
				},
				{
					id: '13',
					title: '房车驿站出现质量问题如何解决？',
					answer: '房车驿站出现质量问题，由厂家负责维修，人为损坏则由购买人负责解决。',
				},
				{
					id: '14',
					title: '房车驿站与公司怎么签订合同？',
					answer: '线下签纸质合同。',
				},
				{
					id: '15',
					title: '房车驿站持有者与公司签约需要什么手续？',
					answer: '需要持个体营业执照。',
				},
				{
					id: '16',
					title: '房车驿站使用期多少年？',
					answer: '5年的使用期，5年之后再根据具体情况续约。',
				},
			],
			answerList1: [],
			index: 0,
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		getSiteData() {
			//获取seo关键字
			let that = this;
			that.$axios
				.post(api.GetSiteData, {})
				.then(function(response) {
					// console.log('seo优化', response);
					let data = response.data;
					that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
					that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
					that.SeoDescription = data.SeoDescription
						? data.SeoDescription
						: '约你游·一站式房车旅游综合服务平台';
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		loadMore() {
			this.isMore = false;
			this.answerList1 = this.answerList;
		},
		goAnchor(selector, index) {
			this.i = index;
			//跳转锚点
			var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id
			document.body.scrollTop = anchor.offsetTop; // chrome
			document.documentElement.scrollTop = anchor.offsetTop; // firefox
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getSiteData();
		this.answerList1 = this.answerList.slice(0, 4);
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {},
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
	padding-bottom: 90px;
}
.container-fluid {
	padding-left: 0 !important;
	padding-right: 0 !important;
}
// .mianbao {
// 	display: flex;
// 	flex-direction: row;
// 	align-items: center;
// 	background: #fbfbfb;
// 	font-size: 14px;
// 	padding: 4px;
// }
.mianbao {
	// display: flex;
	// flex-direction: row;
	// align-items: center;
	background: #fbfbfb;
	font-size: 16px;
	padding: 15px 0;
}
.mianbao_view {
	width: 1250px;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
}
.stage,
.answer_view {
	margin-top: 40px;
}
.ic_more {
	cursor: pointer;
	margin-top: 10px;
}
.answer_left {
	color: #fff;
	font-size: 36px;
	background: #f7c06c;
	height: 51px;
	line-height: 50px;
	text-align: center;
	padding: 0 6px;
}
.answer_right {
	text-align: start;
	margin-left: 20px;
}
.answer_item {
	display: flex;
	flex-direction: row;
	// justify-content: center;
	margin: 10px;
	// margin-top: 20px;
}
@media (min-width: 992px) {
	// .mianbao {
	// 	padding-left: 200px;
	// }
	.stage_title {
		display: none;
	}
	.stage_list {
		justify-content: center;
		margin: 0 15px;
	}
	.stage_text {
		text-align: start;
		color: #666;
		font-size: 16px;
		width: 80%;
		margin: 0 auto !important;
		margin-top: 80px !important;
	}
	.stage,
	.answer_view {
		width: 1200px;
		margin: 0 auto;
	}
	.stage {
		margin-top: 80px;
	}
	.answer_view {
		margin-top: 170px;
	}
	.stage_img {
		margin-top: 80px !important;
	}
	.answer_item {
		margin-top: 30px;
	}
	// .answer_item {
	// 	display: flex;
	// 	flex-direction: row;
	// 	justify-content: center;
	// }
}

@media (max-width: 768px) {
	.mianbao_item {
		flex: 1;
	}
	.mianbao {
		display: none;
	}
	.stage_mid {
		display: none;
	}
	.stage_title {
		display: block;
		color: #ff6537;
		font-size: 20px;
		font-weight: bold;
	}
	.title_img1 {
		display: none;
	}
	.title_text {
		color: #ff6537;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		display: block !important;
	}
}

.title_text {
	display: none;
}
.mianbao_item {
	margin: 0 20px;
	cursor: pointer;
}
.active {
	color: #ff6537;
	font-weight: bold;
}

.stage_img {
	margin-top: 10px;
}
.stage_text {
	text-align: justify;
	color: #666;
	font-size: 16px;
	margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/stage.vue